import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '~/api/queryKeys';

import { TERMINAL_RUN_STATUSES } from '../constants/enums';
import { getWorkflowRunDetail } from '../services/workflow-runs.service';

/** Detail poll cadence (ms) while the run is still live. */
const DETAIL_POLL_MS = 4000;

/**
 * Run detail — reconciled summary + stage checklist. Polls every 4s while the
 * payload reports `live: true` and the run isn't terminal, then stops (the
 * status is reconciled server-side, so a closed run never reports RUNNING).
 */
export function useWorkflowRunDetail(runId: string, enabled = true) {
  return useQuery({
    queryKey: queryKeys.workflowRuns.detail(runId),
    queryFn: () => getWorkflowRunDetail(runId),
    enabled: !!runId && enabled,
    refetchInterval: (query) => {
      const data = query.state.data;
      if (!data) return false;
      if (TERMINAL_RUN_STATUSES.has(data.summary.status)) return false;
      return data.live ? DETAIL_POLL_MS : false;
    },
  });
}
